<template>
	<div style="height:100vh;background:#03152a">
		<el-row class="head-logo">
			<el-col :span="24">
				<span>开放平台管理系统</span>
				<div class="image"><img src="../../public/images/logo.png" alt="" /></div>
			</el-col>
		</el-row>
		<!-- recode==1 -->
		<el-menu
			v-if="leftShow"
			ref="menu"
			:default-active="currentPath"
			:router="true"
			@select="select"
			@open="open"
			:unique-opened="true"
			class="el-menu-vertical-demo"
			background-color="#03152a"
			text-color="rgba(255,255,255,0.6)"
			active-text-color="#ffd04b"
		>
			<el-submenu :index="item1.num" v-for="item1 in menus" :key="item1.id">
				<template slot="title">
					<i :class="item1.icon"></i>
					<span>{{ item1.name1 }}</span>
				</template>
				<el-menu-item :index="item.path" @click="showName(item.name)" v-for="item in item1.children" :key="item.id">
					<template slot="title">
						<span>{{ item.name }}</span>
					</template>
				</el-menu-item>
			</el-submenu>
		</el-menu>
		<!-- recode==13 -->
		<el-menu
			v-if="leftShow1"
			ref="menu"
			:default-active="currentPath"
			:router="true"
			@select="select"
			@open="open"
			:unique-opened="true"
			class="el-menu-vertical-demo"
			background-color="#03152a"
			text-color="rgba(255,255,255,0.6)"
			active-text-color="#ffd04b"
		>
			<el-submenu :index="item1.num" v-for="item1 in menus1" :key="item1.id">
				<template slot="title">
					<i :class="item1.icon"></i>
					<span>{{ item1.name1 }}</span>
				</template>
				<el-menu-item :index="item.path" @click="showName(item.name)" v-for="item in item1.children" :key="item.id">
					<template slot="title">
						<span>{{ item.name }}</span>
					</template>
				</el-menu-item>
			</el-submenu>
		</el-menu>
	</div>
</template>

<script>
import menuOne from '@/config/menu_one.js';
import menuTwo from '@/config/menu_two.js';
export default {
	data() {
		return {
			leftShow: false,
			leftShow1: false,
			currentPath: '/',
			openMenuIndex: 0, //默认导航的index
			menus: menuOne,
			menus1: menuTwo
		};
	},
	watch: {
		//tabs
		$route: function(to) {
			this.currentPath = to.path;
		}
	},
	created() {
		if (sessionStorage.getItem('roleId') == 1) {
			(this.leftShow = true), (this.leftShow1 = false);
		} else if (sessionStorage.getItem('roleId') == 13) {
			(this.leftShow = false), (this.leftShow1 = true);
		}
		//tabs开始
		this.openMenuIndex = localStorage.getItem('menuindex');
		this.showName();
		//tabs结束
	},
	beforeMount() {
		//tabs
		this.currentPath = this.$route.path;
		this.showName(this.$route.meta.title);
	},
	methods: {
		//tabs开始
		select(index) {
			if (index) {
				this.$refs.menu.close(this.openMenuIndex.toString());
				this.$bus.$emit('myIndex', index);
			}
		},
		showName(val) {
			var currentname = val;
			this.$bus.$emit('mycrrname', currentname);
		},
		open(index) {
			localStorage.setItem('menuindex', index);
			this.openMenuIndex = index;
		}
		//tabs结束
	}
};
</script>

<style scoped="scoped">
.head-logo {
	height: 140px;
}

.head-logo .el-col span {
	color: rgba(255, 255, 255, 0.6);
	display: block;
	text-align: center;
	padding: 10px 0;
	font-size: 18px;
}

.head-logo .el-col .image {
	width: 35%;
	height: 35%;
	margin: 10px 0 0 18px;
}

.head-logo .el-col .image img {
	/* background: rgba(255, 255, 255, 0.2); */
	padding: 4px;
	width: 100%;
	height: 100%;
	border-radius: 100%;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
	width: 220px;
	min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
	border: none;
	text-align: left;
}

.el-menu-item-group__title {
	padding: 0px;
}

.el-menu-bg {
	background-color: #1f2d3d !important;
}

.el-menu {
	border: none;
}

.logobox {
	height: 40px;
	line-height: 40px;
	color: #9d9d9d;
	font-size: 20px;
	text-align: center;
	padding: 20px 0px;
}

.logoimg {
	height: 40px;
}
</style>
